<template>
  <div>
    <!-- 线下支付标题栏 -->
    <div class="pay_type">
      <div class="pay_type_left">
        <img
          src="@/assets/order/icon_payment_union.png"
          alt=""
          class="unionpay_icon_img"
        />
        <span class="font12 font_weight500 colo0 line_height_17 offline_font"
          >线下支付</span
        >
      </div>
      <img :src="select" alt="" class="select_icon" />
    </div>

    <!-- 银行账户详情 -->
    <div class="bank_info_card">
      <div class="info_row">
        <span class="info_label">AccName</span>
        <span class="info_value">{{
          corporatePaymentInfo.enterpriseName || ""
        }}</span>
      </div>
      <div class="info_row">
        <span class="info_label">Bank</span>
        <span class="info_value">{{
          corporatePaymentInfo.openingBank || ""
        }}</span>
      </div>
      <div class="info_row">
        <span class="info_label">BSB</span>
        <span class="info_value">{{ corporatePaymentInfo.bsb || "" }}</span>
      </div>
      <div class="info_row">
        <span class="info_label">ACCOUNT</span>
        <span class="info_value">{{
          corporatePaymentInfo.bankAccount || ""
        }}</span>
      </div>
      <div class="info_row spec_row">
        <span class="info_label">请备注</span>
        <div class="info_value_wrap">
          <span class="info_value spec_val"
            >订单号：{{ userOrder.orderSn || $route.query.orderSn }}</span
          >
          <button class="copy_btn" @click="copyOrderSn">复制</button>
        </div>
      </div>
    </div>

    <!-- 上传支付凭证区 -->
    <div class="voucher_upload_section">
      <div class="upload_title font14 font_weight600 colo087">
        上传支付凭证
      </div>
      <div class="uploader_wrapper">
        <van-uploader
          v-model="fileList"
          :after-read="afterRead"
          :max-count="6"
          result-type="file"
        >
          <div class="upload_box" v-if="fileList.length < 6">
            <span class="plus_icon">+</span>
          </div>
        </van-uploader>
      </div>
    </div>

    <!-- 底部悬浮的上传凭证按钮 -->
    <div class="bottom_btn_wrap">
      <div
        class="save_btn font_weight500 font14 colof line_height_20"
        @click="submitVoucher"
      >
        上传支付凭证
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OfflinePay",
  props: {
    userOrder: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      select: require("@/assets/login/select@2x.png"),
      fileList: []
    };
  },
  computed: {
    corporatePaymentInfo() {
      return this.$store.state.order.corporatePaymentInfo || {};
    }
  },
  methods: {
    // 一键复制订单号备注
    copyOrderSn() {
      const orderSn = this.userOrder.orderSn || this.$route.query.orderSn;
      this.$copyText(orderSn)
        .then(() => {
          this.$toast("订单号已复制");
        })
        .catch(() => {
          this.$toast("复制失败，请手动复制");
        });
    },
    // 线下支付凭证图片读取上传
    afterRead(file) {
      this.$toast.loading({
        message: "上传中...",
        forbidClick: true
      });
      this.$store
        .dispatch("mine/upload", {
          params: {
            file: file.file,
            data: {
              kind: "refund",
              sourceId: this.userOrder.orderSn || this.$route.query.orderSn,
              thumbnail: true
            }
          }
        })
        .then(res => {
          this.$toast.clear();
          this.$set(file, "url", res.linkUrl);
          this.$set(file, "fileName", res.name || "");
        })
        .catch(() => {
          this.$toast.clear();
          this.$toast("图片上传失败，请重试");
          const index = this.fileList.indexOf(file);
          if (index !== -1) {
            this.fileList.splice(index, 1);
          }
        });
    },
    // 提交线下汇款凭证
    submitVoucher() {
      const uploadedFiles = this.fileList.filter(item => item.url);
      if (uploadedFiles.length === 0) {
        this.$toast("请先选择并上传支付凭证");
        return;
      }
      this.$toast.loading({
        message: "提交中...",
        forbidClick: true
      });
      const fileUrls = uploadedFiles.map(item => ({
        fileName: item.fileName || "",
        linkUrl: item.url
      }));
      this.$store
        .dispatch("order/uploadPaymentVoucher", {
          params: {
            orderSn: this.userOrder.orderSn || this.$route.query.orderSn,
            fileUrls: fileUrls
          }
        })
        .then(() => {
          this.$toast.clear();
          this.$toast.success("凭证上传成功，等待审核");
          const isFromValet =
            this.$route.query.fromValet == 1 ||
            (this.$routerStack &&
              this.$routerStack.includes("/user/order/fast/qqgpay"));
          if (isFromValet) {
            this.$router.replace({
              path: "/user/order/fast/qqgpay",
              query: {
                orderSn: this.userOrder.orderSn || this.$route.query.orderSn
              }
            });
          } else {
            this.$router.replace({
              path: "/order/detail",
              query: {
                orderSn: this.userOrder.orderSn || this.$route.query.orderSn
              }
            });
          }
        })
        .catch(err => {
          this.$toast.clear();
          this.$toast(err.message || "提交凭证失败，请重试");
        });
    }
  }
};
</script>

<style lang="less" scoped>
.pay_type {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 16px;
  font-size: 0;
  .pay_type_left {
    display: flex;
    align-items: center;
  }
  .offline_font {
    font-size: 14px;
    color: #333;
    vertical-align: middle;
    font-weight: 500;
  }
  .select_icon {
    display: block;
    width: 18px;
  }
  .unionpay_icon_img {
    width: 24px;
    height: 24px;
    margin-right: 12px;
    object-fit: contain;
  }
}

/* 银行账户信息卡片样式 */
.bank_info_card {
  margin: 0 16px 20px;
  background: #fff;
  padding: 8px 0;
  .info_row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    font-size: 13px;
    line-height: 18px;
    .info_label {
      color: #666;
      font-weight: 400;
    }
    .info_value {
      color: #000;
      font-weight: 500;
      text-align: right;
    }
  }
  .spec_row {
    align-items: flex-start;
    .info_value_wrap {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .spec_val {
        max-width: 170px;
        word-break: break-all;
        margin-right: 8px;
        font-size: 11px;
        color: #333;
      }
      .copy_btn {
        border: 1px solid #999;
        background: #fff;
        color: #333;
        border-radius: 10px;
        padding: 2px 8px;
        font-size: 10px;
        outline: none;
        line-height: 12px;
        flex-shrink: 0;
        &:active {
          background: #f0f0f0;
        }
      }
    }
  }
}

/* 上传凭证区样式 */
.voucher_upload_section {
  margin: 0 16px 24px;
  text-align: left;
  .upload_title {
    font-size: 14px;
    font-weight: 600;
    color: #333;
    margin-bottom: 12px;
  }
  .uploader_wrapper {
    margin-top: 8px;
  }
  .upload_box {
    width: 80px;
    height: 80px;
    border: 1px dashed #d9d9d9;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fafafa;
    .plus_icon {
      font-size: 28px;
      color: #999;
      font-weight: 200;
    }
  }
  /* 覆盖 uploader 内部样式，保持精美度 */
  ::v-deep .van-uploader__preview-image {
    width: 80px;
    height: 80px;
    border-radius: 4px;
  }
  ::v-deep .van-uploader__upload {
    width: 80px;
    height: 80px;
    margin: 0;
  }
}

/* 悬浮底栏定位容器 */
.bottom_btn_wrap {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  padding: 12px 16px;
  box-sizing: border-box;
  z-index: 100;
  /* 适配底部刘海安全区域 */
  padding-bottom: calc(12px + constant(safe-area-inset-bottom));
  padding-bottom: calc(12px + env(safe-area-inset-bottom));
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
}

/* 确认支付/上传凭证按钮 */
.save_btn {
  width: 100%;
  background: linear-gradient(90deg, #e1c49d 0%, #bf9264 100%);
  border-radius: 22px;
  padding: 13px 0;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(191, 146, 100, 0.15);
  line-height: 20px;
  &:active {
    opacity: 0.9;
  }
}
</style>
